import React from 'react';
import './App.scss';

import '@aws-amplify/ui-react/styles.css';

import "./fonts/DejaVuSansMono.ttf";
import "./fonts/DejaVuSansMono-Bold.ttf";
import "./fonts/DejaVuSansMono-BoldOblique.ttf";
import "./fonts/DejaVuSansMono-Oblique.ttf";

import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Home from './pages/public/Home';
import LearningSpace from './pages/learningSpace/LearningSpace';
import KurzIndex from './pages/learningSpace/KurzIndex';
import NoMatch from './pages/public/NoMatch';
import SubjectPage from './pages/learningSpace/SubjectPage';
import LessonPage from './pages/learningSpace/LessonPage';
import Menu from './components/Menu';
import Footer from './components/Footer';
import Sale from './pages/public/Sale';
import SignIn from './pages/public/SignIn';
import VideoPlayer from './pages/learningSpace/VideoPlayer';
import DocumentViewer from './pages/learningSpace/DocumentViewer';
import SignUp from './pages/public/SignUp';
import User from './pages/learningSpace/User';
import Blog from './pages/public/Blog';
import BlogPost from './pages/public/BlogPost';
import Payment from './pages/public/Payment';
import Checkout from './pages/public/Checkout';
import LecturesZone from './pages/learningSpace/LecturesZone';
import Practice from './pages/learningSpace/Practice';
import AiTutor from './pages/learningSpace/AiTutor';
import Community from './pages/learningSpace/Community';
import AdminLayout from './pages/admin/AdminLayout';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminLessons from './pages/admin/AdminLessons';
import AdminLessonEditor from './pages/admin/AdminLessonEditor';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminQuestionImport from './pages/admin/AdminQuestionImport';
import AdminQuestionReview from './pages/admin/AdminQuestionReview';
import AdminGroups from './pages/admin/AdminGroups';
import AdminGroupDetail from './pages/admin/AdminGroupDetail';
import AdminChannels from './pages/admin/AdminChannels';
import AdminChannelDetail from './pages/admin/AdminChannelDetail';
import AdminOnline from './pages/admin/AdminOnline';
import AdminFaculties from './pages/admin/AdminFaculties';
import AdminFacultyEditor from './pages/admin/AdminFacultyEditor';
import AdminLibrary from './pages/admin/AdminLibrary';
import AdminCommerce from './pages/admin/AdminCommerce';
import AdminStats from './pages/admin/AdminStats';
import AdminSettings from './pages/admin/AdminSettings';
import AdminBlog from './pages/admin/AdminBlog';
import AdminBlogEditor from './pages/admin/AdminBlogEditor';
import AdminLogs from './pages/admin/AdminLogs';
import { SectionsProvider, RequireSection } from './sections';
import PageLoader from './components/PageLoader';
import { PURCHASES_ENABLED } from './Constants';

const About = React.lazy(() => import("./pages/public/About"));

export default function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
            <Route
              path="kontakty"
              element={
                <React.Suspense fallback={<PageLoader />}>
                  <About />
                </React.Suspense>
              }
            />

            <Route
              path="blog"
              element={
                <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                </React.Suspense>
              }
            >
              <Route index element={<Blog />} />
              <Route path=":postUrl" element={<BlogPost />}/>
            </Route>

            <Route
              path="prihlaseni"
              element={
                <React.Suspense fallback={<PageLoader />}>
                    <SignIn />
                </React.Suspense>
              }
            />

            <Route
              path="registrace"
              element={
                <React.Suspense fallback={<PageLoader />}>
                    <SignUp />
                </React.Suspense>
              }
            />

            <Route
              path="nakup"
              element={
                <React.Suspense fallback={<PageLoader />}>
                    <Sale />
                </React.Suspense>
              }
            />

            <Route
              path="pokladna/:product"
              element={
                PURCHASES_ENABLED ? (
                  <React.Suspense fallback={<PageLoader />}>
                      <Checkout />
                  </React.Suspense>
                ) : (
                  <Navigate to="/nakup" replace />
                )
              }
            />

            <Route
              path="platba/:installmentId"
              element={
                PURCHASES_ENABLED ? (
                  <React.Suspense fallback={<PageLoader />}>
                      <Payment />
                  </React.Suspense>
                ) : (
                  <Navigate to="/nakup" replace />
                )
              }
            />

            <Route path="*" element={<NoMatch />} />
          </Route>

          <Route
            path="/kurz"
            element={<InternalLayout />}
          >
            <Route
              path="ucet"
              element={
                <React.Suspense fallback={<PageLoader />}>
                  <User />
                </React.Suspense>
              }
            />

            <Route
              index
              element={
                <React.Suspense fallback={<PageLoader />}>
                  <KurzIndex />
                </React.Suspense>
              }
            />

            <Route
              path="vyuka"
              element={
                <RequireSection section="OnlineLessons">
                  <React.Suspense fallback={<PageLoader />}>
                    <LecturesZone />
                  </React.Suspense>
                </RequireSection>
              }
            />

            <Route
              path="procvicovani"
              element={
                <RequireSection section="Practice">
                  <React.Suspense fallback={<PageLoader />}>
                    <Practice />
                  </React.Suspense>
                </RequireSection>
              }
            />

            <Route
              path="procvicovani/kviz/:lessonId"
              element={
                <RequireSection section="Practice">
                  <React.Suspense fallback={<PageLoader />}>
                    <Practice />
                  </React.Suspense>
                </RequireSection>
              }
            />

            <Route
              path="tutor"
              element={
                <RequireSection section="AiTutor">
                  <React.Suspense fallback={<PageLoader />}>
                    <AiTutor />
                  </React.Suspense>
                </RequireSection>
              }
            />

            <Route
              path="komunita"
              element={
                <RequireSection section="Community">
                  <React.Suspense fallback={<PageLoader />}>
                    <Community />
                  </React.Suspense>
                </RequireSection>
              }
            />

            <Route
              path="materialy"
              element={
                <RequireSection section="StudyMaterials">
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>
                </RequireSection>
              }
            >
              <Route
                index
                element={
                  <React.Suspense fallback={<PageLoader />}>
                    <LearningSpace />
                  </React.Suspense>
                }
              />

              <Route
                path="fyzika"
                element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>
                }
              >
                <Route index element={<SubjectPage subject="physics" />} />
                <Route path=":lessonNumber" element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>

                }>
                  <Route index element={<LessonPage subject="physics" />} />

                  <Route path="video" element={<VideoPlayer />} />
                  <Route path="dokument" element={<DocumentViewer />} />
                </Route>
              </Route>

              <Route
                path="chemie"
                element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>
                }
              >
                <Route index element={<SubjectPage subject="chemistry" />} />
                <Route path=":lessonNumber" element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>

                }>
                  <Route index element={<LessonPage subject="chemistry" />} />
                  <Route path="video" element={<VideoPlayer />} />
                  <Route path="dokument" element={<DocumentViewer />} />
                </Route>
              </Route>

              <Route
                path="biologie"
                element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>
                }
              >
                <Route index element={<SubjectPage subject="biology" />} />
                <Route path=":lessonNumber" element={
                  <React.Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </React.Suspense>

                }>
                  <Route index element={<LessonPage subject="biology" />} />
                  <Route path="video" element={<VideoPlayer />} />
                  <Route path="dokument" element={<DocumentViewer />} />
                </Route>
              </Route>
            </Route>
          <Route path="*" element={<NoMatch />} />
        </Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/studenti" replace />} />
          <Route path="studenti" element={<AdminUsers />} />
          <Route path="studenti/:id" element={<AdminUserDetail />} />
          <Route path="vyuka" element={<AdminLessons />} />
          <Route path="vyuka/:id" element={<AdminLessonEditor />} />
          <Route path="otazky" element={<AdminQuestions />} />
          <Route path="otazky/import" element={<AdminQuestionImport />} />
          <Route path="otazky/kontrola" element={<AdminQuestionReview />} />
          <Route path="skupiny" element={<AdminGroups />} />
          <Route path="skupiny/:id" element={<AdminGroupDetail />} />
          <Route path="komunita" element={<AdminChannels />} />
          <Route path="komunita/:id" element={<AdminChannelDetail />} />
          <Route path="online" element={<AdminOnline />} />
          <Route path="fakulty" element={<AdminFaculties />} />
          <Route path="fakulty/:id" element={<AdminFacultyEditor />} />
          <Route path="knihovna" element={<AdminLibrary />} />
          <Route path="statistiky" element={<AdminStats />} />
          <Route path="obchod" element={<AdminCommerce />} />
          <Route path="nastaveni" element={<AdminSettings />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="blog/:id" element={<AdminBlogEditor />} />
          <Route path="logy" element={<AdminLogs />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </div>
  );
}

function Layout() {
  return (
    <>
      <Menu />
      <Outlet />
      <Footer />
    </>
  );
}

function InternalLayout() {
  return (
    <SectionsProvider>
      <Menu inner={true} />
      <Outlet />
    </SectionsProvider>
  );
}
